<template>
  <div class="yx-statistics-jxf-page main-layout">
    <CCollapseItem>
      <template slot="title-left"> 征兵报名统计 </template>
      <template slot="body">
        <c-search
          v-model="pageParams"
          :searchItems="searchItems"
          @reset="refresh"
          @search="pageGet(true)"
        >
        </c-search>
      </template>
    </CCollapseItem>
    <el-card class="box-table box-bottom">
      <div slot="header" class="btn-group">
        <!-- 操作按钮 -->
        <div class="btn-left">
          <div class="opt-btn" title="导出" @click="exportExcel">
            <i class="iconfont icon-daochu3" :class="{ disabled: isExport }"></i>
          </div>
        </div>
        <!-- 右侧操作按钮 -->
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="
            idList = [];
            pageGet(true);
          "
        ></table-btns>
      </div>
      <div class="div-scroll">
        <c-table
          :data="pageData"
          :tableColumns="tableColumns"
          :pagination="pageParams"
          @change="pageGet"
          @selectionChange="selectionChange"
          v-loading="pageLoading"
        >
          <template slot="status" slot-scope="scope">
            <span>{{
              scope.row.isOrNot == null
                ? "-"
                : scope.row.isOrNot == 0
                ? "否"
                : "是"
            }}</span>
          </template>
        </c-table>
      </div>
    </el-card>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import MExcel from "@/mixins/MExcel.js";
import Configs from "./data/army";
import CSearch from "@/components/CSearch/index.vue";
import CTable from "@/components/CTable/index.vue";
import TableBtns from "@/components/TableBtns/index.vue";
import { getOrgOptions } from "@/libs/searchSelect.js";
let mPage = MPage({
  pagePath: "/welcome-live/statistics/oneForecastLinkListPage",
  pageDelPath: "",
  pageDelsPath: "",
  pageParams: {
    studentName: "",
    collegeId: "",
    departmentId: "",
    majorId: "",
    classId: "",
    linkId: "",
    isOrNot: null,
  },
  pageExportPath: "/welcome-live/statistics/exportExcel/oneForecast",
  pageExportParams: {},
});
export default {
  mixins: [mPage],
  name: "",
  components: { CSearch, CTable, TableBtns },
  data() {
    let { searchItems, tableColumns } = Configs(this);
    return {
      isFold: false,
      searchItems,
      tableColumns,
      idList: [],
      linkId: "",
      isExport: false, // 是否导出
      message: null,
    };
  },
  created() {
    getOrgOptions(this, { type: "college" }, 0, null);
    this.linkId = this.$route.params.linkId;
    this.pageParams.linkId = this.linkId;
  },
  mounted() {},
  methods: {
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.studentId);
        });
        this.idList = idList;
      }
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    refresh() {
      this.idList = [];
      this.searchItems[1].options = [];
      this.searchItems[2].options = [];
      this.searchItems[3].options = [];
      this.pageParams = {
        studentName: "",
        collegeId: "",
        departmentId: "",
        majorId: "",
        classId: "",
        linkId: this.linkId,
        isOrNot: null,
      };
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    exportExcel() {
      if (this.isExport) {
        return;
      } else {
        this.isExport = true;
        this.message = this.$message({
          message: "数据正在导出中，请稍候！",
          duration: 0,
          type: "warning",
          center: true,
        });
        let params = Object.assign({}, this.pageParams);
        if (!params.academicDegree)
          params.academicDegree = this._CURRENT_ACADEMIC;
        params.enrollmentYear = this._CURRENTYEAR[0].value;
        this.pageExportParams = params;
        if (this.idList.length) {
          this.pageExportParams.studentIdStr = this.idList.join();
        }
        this.pageExport();
      }
    },
    pageExportAfterFn() {
      this.isExport = false;
      this.message.close();
      this.message = null;
      this.refresh();
      this.pageExportParams = {};
    },
  },
};
</script>
